import { render, staticRenderFns } from "./FnFormatNumber.vue?vue&type=template&id=e256887a&"
import script from "./FnFormatNumber.vue?vue&type=script&lang=js&"
export * from "./FnFormatNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e256887a')) {
      api.createRecord('e256887a', component.options)
    } else {
      api.reload('e256887a', component.options)
    }
    module.hot.accept("./FnFormatNumber.vue?vue&type=template&id=e256887a&", function () {
      api.rerender('e256887a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-format/components/FnFormatNumber.vue"
export default component.exports